import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgAdditional = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      d="M10.002 9.188a.25.25 0 0 1-.19.137l-3.95.56a.254.254 0 0 0-.138.436l2.847 2.692c.062.059.09.145.076.229l-.674 3.81a.254.254 0 0 0 .366.27l3.546-1.81a.25.25 0 0 1 .23 0l3.547 1.81a.254.254 0 0 0 .365-.27l-.673-3.81a.25.25 0 0 1 .076-.23l2.847-2.691a.254.254 0 0 0-.139-.436l-3.949-.56a.25.25 0 0 1-.19-.137l-1.772-3.484a.254.254 0 0 0-.453 0z"
      fill={props.color}
    />
    <Path
      clipRule="evenodd"
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0 2c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgAdditional);
export default Memo;
